import { useClient } from '@/components/shared/utilities/AppProvider/AppProvider';
import { UserSingleDocument } from '@/interfaces/IUserResource';
import { serializeSingleResource } from '@/utils/serilize-resource';
import useSWR from 'swr';

export function useUser() {
	const client = useClient();
	const {
		data: user,
		mutate: mutateUser,
		error,
		isValidating,
	} = useSWR(
		'user',
		async (key) => {
			const userResponse = await client.find<UserSingleDocument['data']>(key, 'me');

			return userResponse.data;
		},
		{
			shouldRetryOnError: false,
		}
	);

	return {
		user,
		mutateUser,
		userError: error,
		isUserValidating: isValidating,
		isUserLoading: !user && !error,
	};
}
